module.exports = __webpack_public_path__ + "7cf3cb3379551e022ce81e0cbddff77b.jpg";